module.exports = __webpack_public_path__ + "img/404page.21050f5.png";